import { isMutationActive } from './body.js';
/** Resolve the effective mechanics for an explicitly tagged HFT conveyor. */
export function resolveHftBeltSurface(world, base) {
    if (base?.kind !== 'conveyor' || base.hftRouteGroup === undefined)
        return base;
    let effect = null;
    for (const entry of world.chaos.applied) {
        const mutation = entry.mutation;
        if (mutation.kind !== 'hft_belt_flow' || mutation.routeGroup !== base.hftRouteGroup)
            continue;
        if (isMutationActive(entry, world.tick))
            effect = mutation;
    }
    if (!effect)
        return base;
    return { ...base,
        dirX: base.dirX * effect.directionMultiplier,
        dirZ: base.dirZ * effect.directionMultiplier,
        speed: base.speed * effect.strengthPct / 100 };
}
//# sourceMappingURL=hft-belts.js.map